<div bsModal
     #staticModal="bs-modal"
     class="modal fade"
     tabindex="-1"
     role="dialog"
     aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">X</span>
        </button>
        <storever-header-modal [title]="'ORDER_CANCEL'" [icon]="'fal fa-times-circle'"></storever-header-modal>
      </div>
      <storever-header-subtitle  [datas]="[{icon: 'fa-cart-plus', title: 'GENERIC_ORDER_LABEL', name: (order$|async)?.displayName},
      {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: (order$|async)?.site?.displayName}]
      "></storever-header-subtitle>
      <div class="modal-body">
        <div class="portlet-body" style="text-align:center;">
            {{'CONFIRM_CANCEL_ORDER' | translate:locale.language}}
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="send()">{{'GENERIC_OK' | translate:locale.language}} </button>
        <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>
      </div>
    </div>
  </div>
</div>
